
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/loyalty/nightly-upgrade-awards",
      function () {
        return require("private-next-pages/loyalty/nightly-upgrade-awards/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/loyalty/nightly-upgrade-awards"])
      });
    }
  